const atomic = require('../../../git_modules/@tomandco/atomic/config/ratio');

/**
 * Ratios used to generate atomic classes.
 *
 * WARNING!!! `key` and `value` are required.
 * Other are used in iCMS
 *
 * @example
 * ```css
 *   .ratio-1-1 { position: relative; }
 *   .ratio-1-1::after { paddin-bottom: 100%; }
 * ```
 */
const ratio = [
    // default ratios from atomic
    ...atomic.ratio,
    // custom local ratios
    { key: '1-3', value: 3 / 1, title: '1x3' },
    { key: '2-3', value: 3 / 2, title: '2x3' },
    { key: '3-1', value: 1 / 3, title: '3x1' },
    { key: '3-2', value: 2 / 3, title: '3x2' },
    { key: '3-4', value: 4 / 3, title: '3x4' },
    { key: '3-5', value: 5 / 3, title: '3x5' },
    { key: '4-1', value: 1 / 4, title: '4x1' },
    { key: '4-3', value: 3 / 4, title: '4x3' },
    { key: '4-5', value: 5 / 4, title: '4x5' },
    { key: '5-1', value: 1 / 5, title: '5x1' },
    { key: '5-2', value: 2 / 5, title: '5x2' },
    { key: '5-3', value: 3 / 5, title: '5x3' },
    { key: '5-4', value: 4 / 5, title: '5x4' },
    { key: '6-1', value: 1 / 6, title: '6x1' },
    { key: '7-1', value: 1 / 7, title: '7x1' },
    { key: '8-1', value: 1 / 8, title: '8x1' },
    { key: '8-9', value: 9 / 8, title: '8x9' },
    { key: '9-4', value: 4 / 9, title: '9x4' },
    { key: '10-11', value: 11 / 10, title: '10x11' },
    { key: '10-13', value: 13 / 10, title: '10x13' },
    { key: '16-9', value: 9 / 16, title: '16x9' },
    { key: '16-10', value: 10 / 16, title: '16x10' },
    { key: 'full-page', value: 1, title: 'Full Page' }
];
exports.ratio = ratio;
